/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of InventoryPurchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InventoryPurchaseReturnApi } from './../../api/transaction/purchasereturn.api';
import { InventoryPurchaseReturnData, InventoryPurchaseReturn } from './../../interface/transaction/purchasereturn';

@Injectable()
export class InventoryPurchaseReturnService extends InventoryPurchaseReturnData {

  constructor(private api: InventoryPurchaseReturnApi) {
    super();
  }
searchList(url: string,data:any): Observable<any> {
    
      return this.api.searchList(url,data);
    }
 distinctReason(url: string): Observable<any> {
    return this.api.distinctReason(url);
  }

  list(url: string): Observable<InventoryPurchaseReturn[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<InventoryPurchaseReturn>{
      return this.api.getById(url);
  }

  create(url: string, data:InventoryPurchaseReturn): Observable<InventoryPurchaseReturn> {
    return this.api.add(url,data);
  }

  update(url: string, data:InventoryPurchaseReturn): Observable<InventoryPurchaseReturn> {
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
